<template>
  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="col d-flex align-items-center">
          <h3 class="mb-0">{{ type | capitalise }} Audit Log</h3>
        </div>
        <div class="col-auto">
          <button
            type="button"
            data-toggle="modal"
            data-target=".modal-log-audit"
            class="btn btn-light"
          >
            <font-awesome :icon="['fal', 'search']" /> View Log
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      required: true
    }
  }
}
</script>
